/**
 * ResultLinkFilter Component
 */

import { stripHTMLTagsFromString } from '../../../../utils/string';

import * as React from 'react';

import { IQueryStringContext, QueryStringContext } from '../../../../contexts/queryString';
import { IResultLinkProps, ResultLink } from './ResultLink';

interface IOwnProps extends
  Pick<IResultLinkProps, 'className' | 'label'>,
  Pick<IQueryStringContext, 'addSearchFilter'> {
  filter: SearchFilter;
  isTaxonomyQuery?: boolean;
  onAddSearchFilter?(filter: SearchFilter): void;
}

type IResultLinkFilterProps = IOwnProps;

class InternalResultLinkFilter extends React.PureComponent<IResultLinkFilterProps> {
  onClick = () => {
    const { filter } = this.props;
    this.props.addSearchFilter({name: stripHTMLTagsFromString(filter.name), taxonomy: filter.taxonomy});

    if (this.props.onAddSearchFilter) {
      this.props.onAddSearchFilter(filter);
    }
  }

  render() {
    return (
      <ResultLink onClick={this.onClick} className={this.props.className} label={this.props.label} />
    );
  }
}

export const ResultLinkFilter: React.SFC<Omit<IOwnProps, 'addSearchFilter'>> = (props) => (
  <QueryStringContext.Consumer>
    {({ addSearchFilter, addTaxonomyQuery }) => {
      const operation = props.isTaxonomyQuery ? addTaxonomyQuery : addSearchFilter;
      return <InternalResultLinkFilter addSearchFilter={operation} {...props} />;
    }}
  </QueryStringContext.Consumer>
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/global/InstantSearch/ResultLinkFilter.tsx